import api from "../services/api";

export const fillContactUsForm = (data) => {
    return api.post('common/contactus/fill',
        { ...data },
        {
            headers: {
                'Content-Type': 'application/json',
            }
        });
}

export const getCommonContent = (queryParams) => {
    return api.get(`common/common_content${queryParams}`, {
        headers: {
            'Content-Type': 'application/json',
        },
    });
};

export const getQuestions = (queryParams) => {
    return api.get(`common/questions${queryParams}`, {
        headers: {
            'Content-Type': 'application/json',
        },
    });
};